<template>
  <el-dialog
    title='提示'
    :visible.sync='dialogVisible'
    top='20%'
    width='20%'
    :close-on-click-modal='false'
    @close='dialogClose'>
    <el-form ref='ruleForm' :model='form' label-width='120px' :inline='false'
             class='demo-form-inline flex1'
             :rules='rules'>
      <el-form-item label='退回环节:' prop='fallbackCode'>
        <el-select style='width: 100%;' v-model='form.fallbackCode' filterable size='mini'>
          <el-option label='回退到待审核状态' :value='0' />
          <el-option label='回退到填写发票状态' :value='1' />
        </el-select>
      </el-form-item>
    </el-form>
    <div class='btnContainer mt20'>
      <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
      </el-button>
      <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { fallbackInvoice } from '@/service/getData';

  export default {
    name: 'statementReturned',
    data() {
      return {
        submitLoading: false,
        dialogVisible: false,
        defaultForm: {},
        form: {
          id: '',
          fallbackCode: '',
          reconciliator: ''
        },
        rules: {
          fallbackCode: [{
            required: true,
            message: '请选择退回环节',
            trigger: 'blur',
          }],
        },
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id,reconciliator) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.id = id;
        this.form.reconciliator = reconciliator
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await fallbackInvoice(this.form);
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
            this.$emit('success');
          }
        });

      },
    },
  };
</script>

<style scoped>

</style>
